module.exports = __webpack_public_path__ + "img/begin_btn.c38be31c.png";